import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NotificationService } from './core/services/notification/notification.service';
import { MessageBoxComponent } from './shared/components/message-box/message-box';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CommonModule, MessageBoxComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('holding-tank-app');
  protected readonly notificationService = inject(NotificationService);

  onNotificationHidden(id: number): void {
    this.notificationService.dismiss(id);
  }
}
